import template from './index.pug'

export default {
  name: 'password-input',
  template: template(),
  inheritAttrs: false,
  props: {
    value: [String, Number],
    autocomplete: {
      type: String,
      default: 'current-password'
    }
  },
  data() {
    return {
      revealed: false
    }
  },
  computed: {
    toggleLabel() {
      return this.$t(this.revealed ? 'passwordInput.hide' : 'passwordInput.show')
    }
  },
  methods: {
    toggle() {
      this.revealed = !this.revealed
    }
  }
}
